import React, { useState, useEffect } from "react";
import dayjs from "dayjs";
import Calendar from "react-calendar";
import Navigation from "components/Navigation";
import SubHeader from "components/common/SubHeader";
import { getMySchedule } from "api/user";
import useUserStore from "@store/useUserStore";
import Blank from "components/common/Blank";
import useRefreshCallback from "hooks/useRefreshCallback";

// 날짜별 그룹핑 함수
const groupByDate = (list) => {
    return list.reduce((acc, cur) => {
        const date = cur.date || cur.schedule_info.date;
        if (!acc[date]) acc[date] = [];
        acc[date].push(cur);
        return acc;
    }, {});
};

const MyReservation = () => {
    const today = dayjs().startOf("day");
    const userInfo = useUserStore((state) => state.userInfo);
    const [selectedDate, setSelectedDate] = useState(new Date());
    const [schedules, setSchedules] = useState([]);
    const [groupedSchedules, setGroupedSchedules] = useState({});
    // const grouped = groupByDate(schedules);
    // const sortedDates = Object.keys(grouped).sort();

    useRefreshCallback(() => {
        if (userInfo !== null) {
            return getMySchedule().then((res) => {
                const scheduleList = [...res.lessons, ...res.practices];
                const sortedScheduleList = scheduleList.sort((a, b) => {
                    return (
                        new Date(b?.schedule_info?.date || b?.date) -
                        new Date(a?.schedule_info?.date || a?.date)
                    );
                });
                const grouped = groupByDate(sortedScheduleList);
                setSchedules(sortedScheduleList);
                setGroupedSchedules(grouped);
            });
        }
        return Promise.resolve();
    });

    //로그인 정보가 없을 시 로그인화면으로 이동
    useEffect(() => {
        if (userInfo !== null) {
            getMySchedule()
                .then((res) => {
                    const scheduleList = [...res.lessons, ...res.practices];

                    const sortedScheduleList = scheduleList.sort((a, b) => {
                        return (
                            new Date(b?.schedule_info?.date || b?.date) -
                            new Date(a?.schedule_info?.date || a?.date)
                        );
                    });

                    const grouped = groupByDate(sortedScheduleList);

                    setSchedules(sortedScheduleList);
                    setGroupedSchedules(grouped);
                })
                .catch((err) => {
                    console.error("오류:", err);
                });
        }
    }, []);
    const handleClickDay = (date) => {
        setSelectedDate(date);
    };

    return (
        <div className="page-myreservation">
            <Navigation />
            <SubHeader title="예약내역" />
            <div className="reservation-list">
                {Object.keys(groupedSchedules)
                    .sort()
                    .map((date) => (
                        <section
                            key={date}
                            className="reservation-date-section"
                        >
                            <div className="date-header">
                                {dayjs(date).format("YYYY. M. D dddd")}
                                {dayjs(date).isSame(dayjs(), "day") && (
                                    <span className="today-label"> | 오늘</span>
                                )}
                            </div>
                            {groupedSchedules[date].map((resv, idx) => {
                                const info = resv.schedule_info || resv;
                                return (
                                    <div
                                        className={"reservation-card"}
                                        key={`reservation-${resv.id}-${idx}`}
                                        tabIndex={0}
                                    >
                                        <div className="time">
                                            {`${info.start_time.slice(
                                                0,
                                                5
                                            )} - ${info.end_time.slice(0, 5)}`}
                                        </div>
                                        <h2 className="class title">
                                            <b>
                                                {info.lesson_product_display_name ||
                                                    info.schedule_title}
                                            </b>
                                        </h2>
                                        <div className="info">
                                            <strong>
                                                {info.instructor_name} 강사
                                            </strong>{" "}
                                            딥스프리다이빙 |{" "}
                                            {info.location_name}
                                        </div>
                                        {resv.status && (
                                            <div
                                                className={`my-status ${
                                                    resv.status === "RESERVED"
                                                        ? "reserved"
                                                        : "absence"
                                                }`}
                                            >
                                                {resv.status === "RESERVED"
                                                    ? "예약완료"
                                                    : "결석"}
                                            </div>
                                        )}
                                    </div>
                                );
                            })}
                        </section>
                    ))}
                <Blank height={80} />
            </div>
        </div>
    );
};

export default MyReservation;
